<template>
    <div class="tk-option-pills">
        <q-btn
            v-for="option in options"
            :key="option.value"
            :class="[
                'tk-option-pill',
                { 'tk-option-pill--selected': isSelected(option.value) },
            ]"
            flat
            no-caps
            rounded
            type="button"
            :label="option.label"
            :aria-pressed="isSelected(option.value)"
            @click="toggle(option.value)"
        />
    </div>
</template>

<script>
const includesOption = (selectedValues, optionValue) => (
    selectedValues.some(selectedValue => String(selectedValue) === String(optionValue))
);

const toggleOption = (selectedValues, optionValue) => (
    includesOption(selectedValues, optionValue)
        ? selectedValues.filter(selectedValue => String(selectedValue) !== String(optionValue))
        : [...selectedValues, optionValue]
);

export default {
    name: "TkOptionPillGroup",
    emits: ["update:modelValue"],
    props: {
        modelValue: {
            type: Array,
            required: true,
        },
        options: {
            type: Array,
            required: true,
        },
    },
    methods: {
        isSelected(optionValue) {
            return includesOption(this.modelValue, optionValue);
        },
        toggle(optionValue) {
            this.$emit("update:modelValue", toggleOption(this.modelValue, optionValue));
        },
    },
};
</script>

<style scoped>
.tk-option-pills {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
}

.tk-option-pill {
    min-height: 34px;
    padding: 0 14px;
    border: 1px solid rgba(47, 62, 70, 0.2);
    background: #fff;
    color: #4e5c56;
}

.tk-option-pill:hover,
.tk-option-pill:focus-visible {
    border-color: #4d8f77;
    background: rgba(77, 143, 119, 0.07);
}

.tk-option-pill--selected,
.tk-option-pill--selected:hover,
.tk-option-pill--selected:focus-visible {
    border-color: #3f7e69;
    background: #e3f1ec;
    color: #285f4d;
}

.tk-option-pill :deep(.q-btn__content) {
    font-size: 0.82rem;
    font-weight: 450;
}
</style>
